import React, { useEffect } from 'react'
import CenterStage from '../../../Components/CenterStage/CenterStage';
import SectionHeader from '../../../Components/SectionHeader/SectionHeader';
import ImageText from '../../../Components/ImageText/ImageText';
import imgPlaceholder from '../../../assets/TimelinePlaceholder.png'
import imgHANSA_FLEX__BRANCH_SERBIA_ZEMUN from '../../../assets/Journey/HANSA_FLEX__BRANCH_SERBIA_ZEMUN.webp'
import NumberGrid from '../../../Components/NumberGrid/NumberGrid';
import ThreeDImageCarousel from '../../../Components/CircleCarousel/CircleCarousel';
import { Button } from 'react-bootstrap';
import Promoter from '../../../Components/Promoter/Promoter';
import imgHANSA_FLEX_STARTOFCYLINDERCENTRE from '../../../assets/Journey/HANSA_FLEX_STARTOFCYLINDERCENTRE.webp'
import imgSerbia_Zemun1 from '../../../assets/Branch/Zemun/Serbia_Zemun1.jpg';
import imgSerbia_Zemun2 from '../../../assets/Branch/Zemun/Serbia_Zemun2.jpg';
import imgSerbia_Zemun3 from '../../../assets/Branch/Zemun/Serbia_Zemun3.jpg';
import imgSerbia_Zemun4 from '../../../assets/Branch/Zemun/Serbia_Zemun4.jpg';
import imgSerbia_Zemun5 from '../../../assets/Branch/Zemun/Serbia_Zemun5.jpg';
import imgSerbia_Zemun6 from '../../../assets/Branch/Zemun/Serbia_Zemun6.jpg';
import imgSerbia_Zemun7 from '../../../assets/Branch/Zemun/Serbia_Zemun7.jpg';
import imgSerbia_Zemun8 from '../../../assets/Branch/Zemun/Serbia_Zemun8.jpg';
import imgSerbia_Zemun9 from '../../../assets/Branch/Zemun/Serbia_Zemun9.jpg';
import imgCylinder1 from '../../../assets/Branch/Cylinder/Cylinder1.jpg';
import imgCylinder2 from '../../../assets/Branch/Cylinder/Cylinder2.jpg';
import imgCylinder3 from '../../../assets/Branch/Cylinder/Cylinder3.jpg';
import imgCylinder4 from '../../../assets/Branch/Cylinder/Cylinder4.jpg';
import imgCylinder5 from '../../../assets/Branch/Cylinder/Cylinder5.jpg';
import imgCylinder6 from '../../../assets/Branch/Cylinder/Cylinder6.jpg';
import imgCylinder7 from '../../../assets/Branch/Cylinder/Cylinder7.jpg';


const Branch1 = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);


    const carouselData2 = [
        {
            image: imgCylinder1,
        },
        {
            image: imgCylinder2,
        },
        {
            image: imgCylinder3,
        },
        {
            image: imgCylinder4,
        },
        {
            image: imgCylinder5,
        },
        {
            image: imgCylinder6,
        },
        {
            image: imgCylinder7,
        },

    ]

    const carouselData = [
        {
            image: imgSerbia_Zemun1,
        },
        {
            image: imgSerbia_Zemun2,
        },
        {
            image: imgSerbia_Zemun3,
        },
        {
            image: imgSerbia_Zemun4,
        },
        {
            image: imgSerbia_Zemun5,
        },
        {
            image: imgSerbia_Zemun6,
        },
        {
            image: imgSerbia_Zemun7,
        },
        {
            image: imgSerbia_Zemun8,
        },
        {
            image: imgSerbia_Zemun9,
        },
    ]

    return (
        <div>
            <CenterStage imageSrc={imgHANSA_FLEX__BRANCH_SERBIA_ZEMUN} title={"Welcome to HANSA-FLEX Beograd-Zemun"} paragraph={"The oldest branch of HANSA-FLEX Serbia, founded in 2001. It changed it’s address several times and now is located in the new facility on the old Novi Sad highway. Beside usual HANSA-FLEX products and services, here you can rebuild or make completely new hydraulic cylinder, thanks to the experience team and large stock of original HANSA-FLEX parts for cylinders.Beside Zemun and Novi Beograd, the branch covers the region which includes Pazova, Ruma, Sremska Mitrovica, Šid, Šabac, Loznica..."}
                buttonName={"Contact us"} buttonLink={"/contact-us"}
            />
            <ThreeDImageCarousel items={carouselData2} />

            <div className="text-center div-gray">
                <SectionHeader
                    title={"📞 At Your Service – We're Just a Call Away!"}
                    subtitle={"We’re here when you need us most. Whether it’s regular maintenance or an emergency situation, our team is available around the clock to provide expert hydraulic service and support."}
                />
                
                <Button variant="danger" className="ImageText-button m-2" href='/contact-us'>{("24h SERVICE")}</Button>
                <Button variant="danger" className="ImageText-button" href='/contact-us'>{("FLEXXPRESS 24h")}</Button>
                <br /><br /><br />
            </div>

            <ThreeDImageCarousel items={carouselData} />
        </div>
    )
}

export default Branch1